import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=63684eda&scoped=true&"
import script from "./roleEdit.vue?vue&type=script&lang=js&"
export * from "./roleEdit.vue?vue&type=script&lang=js&"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=63684eda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63684eda",
  null
  
)

export default component.exports